import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import homePageStyle from "./homePageStyle";
import SalesPanel from "../../SalesPanel/SalesPanel";
import Layout from "../../Layout/Layout";

const useStyles = makeStyles((theme) => homePageStyle(theme));

const HomePage = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Layout>
                <SalesPanel />;
            </Layout>
        </div>
    );
};

export default HomePage;
